module.exports = __webpack_public_path__ + "static/media/measure.1004967d.svg";